import React from 'react';

interface Props {
  children: React.ReactNode;
}

// Small red status tag rendered next to the container number field on the
// order surfaces (modal + ProDetail). Used for IN BOND, CES, RSV, and any
// future single-word attention flags. `flex-none` is included by default so
// the badge keeps its size inside flex-row parents like the OrderFormView Row.
const ContainerBadge: React.FC<Props> = ({ children }) => (
  <span className="inline-flex items-center px-1.5 py-0.5 text-[0.625rem] font-semibold leading-none bg-red-600 text-white rounded flex-none">
    {children}
  </span>
);

export default ContainerBadge;